<template>
  <nuxt-link
    class="item"
    :to="url"
    :class="{ selected: forceSelected }"
    @click.capture="handleClickButton"
  >
    <span>{{ label }}</span>

    <icon v-if="iconName" size="1.6rem" class="icon" :name="iconName" />
  </nuxt-link>
</template>
<script setup lang="ts">
interface Props {
  label: string;
  url: string;
  iconName?: string;
  forceSelected?: boolean;
  isMainContent?: boolean;
  size?: 'small' | 'normal' | 'medium';
  rounded?: boolean;
  singleLine?: boolean;
  type?: 'default' | 'statistics' | 'nomad';
}

const props = defineProps({
  label: null,
  url: null,
  iconName: { default: 'nomad:book' },
  forceSelected: { type: Boolean, default: false },
  isMainContent: { type: Boolean },
  size: { default: 'normal' },
  rounded: { type: Boolean, default: true },
  singleLine: { type: Boolean, default: false },
  type: { default: 'default' }
});

const profile = useProfileStore();

const handleClickButton = (e) => {
  if (props.isMainContent) {
    const url = profile.isParent
      ? `/${Sections.ParentForYou}`
      : `/${Sections.Revisions}`;
    navigateTo(url);
    e.preventDefault();
  }
};
</script>
<style lang="scss" scoped>
.item {
  @include font('s', 500, 'secondary');

  display: flex;
  position: relative;
  flex: 1 0 auto;
  align-items: center;
  align-self: center;
  justify-content: center;
  height: 6rem;
  padding: 0 1rem;
  gap: var(--gap_xs);
  text-align: center;
  &::after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: calc(100%);
    height: 0.2rem;
  }
  &.selected,
  &.router-link-active,
  &.router-link-exact-active-with-hash {
    @include font('s', 600, 'secondary');

    color: var(--color_primary);
    &::after {
      background-color: var(--color_primary);
    }
  }
}
</style>
